import IconArrowRight from "@/components/icons/IconArrowRight"
import { formatDate } from "@/lib/utils"
import { urlForImage } from "@/sanity/lib/image"
import MuxVideo from '@/components/MuxVideo'
import Image from "next/image"

interface PressCardProps {
	headline: string
	date: string
	url: string
	image?: any
	video?: any
	excerpt?: string
}

export default function PressCard({headline, date, url, image, video, excerpt}:PressCardProps) {
	video && console.log('video:', video?.asset?.playbackId)
	return (
		<a href={url} target="_blank" className="text-lg leading-110 group">
			{(image && !video) && (
				<div className="relative">
					<Image
						className="w-full rounded-[8px] opacity-100 group-hover:opacity-25 transition-opacity"
						src={urlForImage(image).width(1080).url()}
						sizes={`(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw`}
						width={image?.asset?.metadata?.dimensions?.width}
						height={image?.asset?.metadata?.dimensions?.height}
						alt={headline}
						placeholder="blur"
						blurDataURL={image?.asset?.metadata?.lqip}
						quality={90}
					/>
					<div className={`absolute inset-center opacity-0 group-hover:opacity-100 transition-opacity inline-flex items-center gap-1`}>
						<span className="inline-block mt-[-0.1em]">(</span><span className="inline-block pr-[0.1em]">Visit</span><IconArrowRight className="inline-block size-5 -rotate-45" /><span className="inline-block mt-[-0.1em]">)</span>
					</div>
				</div>
			)}
			{video && (
				<div className="relative" style={{ aspectRatio: video?.asset?.data?.aspect_ratio?.toString()?.replaceAll(':', '/') || '16/9' }}>
					<MuxVideo
						className={`block w-full h-auto rounded-[8px] opacity-100 group-hover:opacity-25 transition-opacity`}
						playbackId={video?.asset?.playbackId}
					/>
					<div className={`absolute inset-center opacity-0 group-hover:opacity-100 transition-opacity inline-flex items-center gap-1`}>
						<span className="inline-block mt-[-0.1em]">(</span><span className="inline-block pr-[0.1em]">Visit</span><IconArrowRight className="inline-block size-5 -rotate-45" /><span className="inline-block mt-[-0.1em]">)</span>
					</div>
				</div>
			)}
			<div className="flex items-start justify-between gap-5 mt-4 font-400 text-xl">
				<span>{headline}</span>
				<span className="md:hidden">
					<IconArrowRight className="w-5 h-5 -rotate-45 mt-2" />
				</span>
			</div>
			{excerpt && <p className="mt-3 font-400 text-base leading-130 text-grey dark:text-grey-dark">
				{excerpt}
			</p>}
			<div className="flex items-start justify-between gap-5 mt-3 text-sm leading-105 text-grey dark:text-grey-dark group-hover:text-black dark:group-hover:text-white transition">
				{formatDate(new Date(date))} — Press
			</div>
		</a>
	)
}

